import { Helmet } from "react-helmet-async";
import { Bell, FileText, Landmark, MapPin, Radar } from "lucide-react";
import { useLang } from "../i18n";
import { usePwaInstall } from "../hooks/usePwaInstall";
import InstallCta from "../components/InstallCta";

const FEATURES = [
  { icon: MapPin, key: "install.f1" },
  { icon: Landmark, key: "install.f2" },
  { icon: Bell, key: "install.f3" },
  { icon: FileText, key: "install.f4" },
  { icon: Radar, key: "install.f5" },
];

export default function InstallPage() {
  const { t } = useLang();
  const { installed } = usePwaInstall();

  return (
    <div data-testid="install-page" className="mx-auto max-w-3xl px-4 py-10 sm:px-6">
      <Helmet>
        <title>Pobierz aplikację PlanGmina</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="PlanGmina zawsze pod ręką — sprawdzaj działki, monitoruj zmiany planistyczne i wracaj do zapisanych analiz." />
      </Helmet>

      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-10">
        <div className="flex flex-col items-center text-center">
          <img data-testid="install-page-icon" src="/pwa/icon-192.png" alt="PlanGmina" className="h-24 w-24 rounded-2xl shadow-md" />
          <img src="/logo.png" alt="PlanGmina" className="mt-5 h-8 w-auto sm:h-10" />
          <h1 className="mt-5 font-heading text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            {t("install.page_title")}
          </h1>
          <p className="mt-3 max-w-xl text-base leading-relaxed text-slate-600">
            {t("install.page_sub")}
          </p>
          <div className="mt-7">
            <InstallCta testId="install-page-cta" buttonClass="border-[#DC143C] text-[#DC143C] hover:bg-[#FEF2F2]" />
          </div>
          {installed && (
            <p className="mt-3 text-xs text-slate-500">{t("install.installed_hint")}</p>
          )}
        </div>

        <ul data-testid="install-page-features" className="mx-auto mt-10 grid max-w-xl gap-3 sm:grid-cols-2">
          {FEATURES.map((f) => (
            <li key={f.key} data-testid={`install-feature-${f.key.split(".")[1]}`} className="flex items-center gap-3 rounded-xl border border-slate-100 bg-slate-50 px-4 py-3">
              <f.icon size={17} className="shrink-0 text-[#DC143C]" />
              <span className="text-sm font-medium text-slate-800">{t(f.key)}</span>
            </li>
          ))}
        </ul>

        <p data-testid="install-page-offline-note" className="mt-8 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-center text-xs leading-relaxed text-slate-500">
          {t("install.offline_note")}
        </p>
      </div>
    </div>
  );
}
